namespace Ir.Components.Filters.SwitchFilter {
    interface ISwitchFilterViewModel {
        filter: Filter;
        switchSettings: DevExpress.ui.dxSwitch.Properties;
    }

    export function getViewModel(this: ISwitchFilterViewModel, params: IFilterParameterVM) {
        let self = this;
        this.filter = params.filter;

        this.switchSettings = {
            value: this.filter.switchChecked as any,
            disabled: this.filter.readOnly as any,
            switchedOffText: this.filter.switchFalseLabel as any,
            switchedOnText: this.filter.switchTrueLabel as any,
            width: `${(Math.max(this.filter.switchTrueLabel().length, this.filter.switchFalseLabel().length) * 8 + 18)}px`,
            onValueChanged: function (data) {
                if (data.previousValue !== data.value) {
                    self.filter.switchChecked(data.value);
                    self.filter.publish();
                }
            }
        }
    }
}